import React from 'react';
import withIcon from '../utilities/withIcon';

const IconEye = () => {
  return (
    <g>
      <path d="M7.999 2c2.65 0 5.258 1.889 7.86 5.567a.75.75 0 0 1-.002.871C13.212 12.114 10.607 14 7.999 14 5.39 14 2.786 12.114.14 8.438a.75.75 0 0 1-.003-.871C2.74 3.889 5.348 2 7.998 2zm0 1.5c-1.862 0-3.857 1.315-5.958 4.017l-.225.295-.138.184.142.188c2.064 2.703 4.003 4.114 5.785 4.296l.198.015.196.005c1.824 0 3.819-1.317 5.95-4.021l.23-.295.14-.188-.137-.184C12.15 5.11 10.213 3.702 8.4 3.52l-.201-.015-.2-.005zM8 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" />
    </g>
  );
};

export default withIcon(IconEye);
